<template>
  <div class="company-list-wrap">
    <div class="side-menu-wrap">
      <ListItemTree></ListItemTree>
    </div>

  </div>
</template>

<script>
import ListItemTree from '../common/ListItemTree.vue'

export default {
  data() {
    return {

    }
  },
  components: {
    ListItemTree
  },
  methods: {

  }
}
</script>
